import { render } from "./NewVersionPanel.vue?vue&type=template&id=2a579dc4&scoped=true"
import script from "./NewVersionPanel.vue?vue&type=script&lang=js"
export * from "./NewVersionPanel.vue?vue&type=script&lang=js"

import "./NewVersionPanel.vue?vue&type=style&index=0&id=2a579dc4&scoped=true&lang=css"

import exportComponent from "/Users/tirinox/Projects/thorviz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a579dc4"]])

export default __exports__